export const getAge = (ageInYearsAndMonths: string) => {
  return ageInYearsAndMonths.split(' Years')[0];
};
